import { datadogRum } from "@datadog/browser-rum";
import { normalizeError } from "./errors";

/**
 * Sends a handled error to Datadog RUM and the console.
 *
 * Only unhandled crashes reach RUM on their own, so anything we catch and turn
 * into an error state has to be reported explicitly or it is invisible in
 * monitoring — which is how a stack-wide 403 went unnoticed until a user
 * reported a hung page.
 */
export function reportError(
  error: unknown,
  context: Record<string, unknown> = {},
): void {
  const normalized = normalizeError(error);

  const errorContext = {
    ...context,
    errorKind: normalized.kind,
    statusCode: normalized.statusCode,
    foundryErrorName: normalized.errorName,
    foundryErrorInstanceId: normalized.errorInstanceId,
  };

  datadogRum.addError(error, errorContext);
  console.error("[unruly]", normalized.message, errorContext, error);
}
